module.exports = __webpack_public_path__ + "assets/img/conversion_coin.952421c2.png";